import { IonActionSheet } from '@ionic/react';
import { FileCopy } from '@mui/icons-material';
import { Button, Descr, LWTXT } from 'components/page';
import * as Table from 'components/table';
import { ContextGlobal as CG } from 'contexts';
import { iframeLink } from 'core/iframe';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from 'react-use';
import { RelationshipCard } from './RelationshipCard';
import * as Styled from './StyledRelationship';

export function Relationship(props) {
    const { emitAlert } = React.useContext(CG);
    const { t } = useTranslation('ranking');
    const [showAS, setShowAS] = React.useState(false);
    const [copy, setCopy] = useCopyToClipboard();
    const {
        deleteStartupRelationship,
        postStartupRelationshipValidation,
        postStartupRelationshipValidationEmail
    } = props.useRankingStartup;
    const data = props.data || props.relationship || undefined;

    const relationship = {
        companyName: data.company.name,
        programName: data?.program?.name
    };
    if (data.company && data.company.contact && data.company.contact.name) {
        relationship.fullName = data.company.contact.name;
    }
    if (data.startup && data.company.contact && data.company.contact.email) {
        relationship.email = data.company.contact.email;
    }
    if (data.year) {
        relationship.year = `${data.year}`;
    }

    // Properties for the table
    const propsTable = {
        href: `/ranking/latam/startup/step7/edit/${data._id}`,
        subtitle: {
            link: t('glossary:edit'),
            icon: 'far fa-pencil'
        },
        object: {
            data: { ...relationship },
            name: 'Relationship',
            dataConv: {}
        }
    };
    if (data.company.status === 'rejected') {
        propsTable.href = undefined;
        propsTable.subtitle = {
            link: '',
            icon: ''
        };
    }

    const closeModal = () => {
        if (props.closeModal) props.closeModal();
        return true;
    };

    function handleConfirm() {
        const payload = {
            _id: data._id,
            status: 'confirmed',
            lastUpdated: data.lastUpdated
        };
        return postStartupRelationshipValidation(payload).then(closeModal);
    }
    function handleDelete() {
        const payload = { _id: data._id };
        return deleteStartupRelationship(payload).then(res => {
            closeModal();
            emitAlert(t('relationshipDeleted'));
            return res;
        });
    }
    function handleReject() {
        const payload = {
            _id: data._id,
            status: 'rejected',
            lastUpdated: data.lastUpdated
        };
        return postStartupRelationshipValidation(payload).then(closeModal);
    }
    function handleResend() {
        const payload = { _id: data._id };
        return postStartupRelationshipValidationEmail(payload).then(res => {
            emitAlert(t('relationshipResent'));
            return res;
        });
    }
    function handleReaudit() {
        emitAlert(t('relationshipReauditSent'));
    }

    const buttons = [];
    if (data.startup && data.status === 'pending' && data.startup.status === 'pending') {
        const s = { type: 'success', onClick: handleConfirm };
        const d = { type: 'danger', onClick: handleReject };
        buttons.push(() => (
            <Styled.RelationshipButtons>
                <Button {...s}>{t('glossary:confirm')}</Button>
                <Button {...d}>{t('glossary:reject')}</Button>
            </Styled.RelationshipButtons>
        ));
    }
    if (data.company && data.status === 'pending' && data.company.status === 'pending') {
        buttons.push(() => (
            <Button type="dark" onClick={handleResend}>
                <span className="text">{t('glossary:resend')}</span>
                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
            </Button>
        ));
    }
    if (data.audited === 'rejected' && data.displayAudit) {
        buttons.push(() => (
            <Button type="dark" onClick={handleReaudit}>
                <span className="text">{t('glossary:reaudit')}</span>
                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
            </Button>
        ));
    }
    if (data.company && data.company.status === 'pending') {
        const l = { type: 'link', onClick: () => setShowAS(true) };
        buttons.push(() => <Button {...l}>{t('relationshipDelete')}</Button>);
    }

    return (
        <Styled.Relationship className={props.className} style={props.style}>
            <RelationshipCard data={data} />

            <Table.Table {...propsTable} />
            <Styled.ContractIdContainer>
                <span>
                    {data?._id}
                    <Styled.CopyButton
                        type="dark"
                        variant="neutral"
                        onClick={() => setCopy(data?._id)}
                    >
                        <FileCopy> </FileCopy>
                        {!copy.value && <span className="text"> </span>}
                        {!!copy.value && <span className="text"> </span>}
                    </Styled.CopyButton>
                </span>
                <p>ID</p>
            </Styled.ContractIdContainer>
            {data.description && <Descr>{data.description}</Descr>}
            {data.linkUrl && (
                <LWTXT to={iframeLink(data.linkUrl)}>
                    <span className="link">{data.linkUrl}</span>
                </LWTXT>
            )}

            {buttons.map((Btn, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <Btn key={`button-${k}`} />
            ))}
            <IonActionSheet
                isOpen={showAS}
                onDidDismiss={() => setShowAS(false)}
                buttons={[
                    {
                        text: t('relationshipDelete'),
                        role: 'destructive',
                        handler: handleDelete
                    },
                    {
                        text: t('glossary:cancel'),
                        role: 'cancel'
                    }
                ]}
            />
        </Styled.Relationship>
    );
}
export default Relationship;
